const redirectToOrderItem = path => {
  window.location.assign(path);
};

export default redirectToOrderItem;
